import Tag from 'library/components/tag';
import Color from 'library/components/color';
import { MODES } from 'library/components/color/constants';
import { FILTER_KEYS } from 'store/browse-items/fixtures';
import {
  Container,
  QueryItemContainer,
  TagIcon,
  TagText,
} from './styles';

const QUERY_CLASSNAMES = {
  [FILTER_KEYS.ITEMS]: 'icon-pencil',
  [FILTER_KEYS.TAGS]: 'icon-tag',
  [FILTER_KEYS.CATEGORIES]: 'icon-category',
  [FILTER_KEYS.MANUFACTURERS]: 'icon-manufacturer',
  [FILTER_KEYS.QUANTITY]: 'icon-layers',
  [FILTER_KEYS.STORAGE]: 'icon-drawer',
  [FILTER_KEYS.QUERY]: 'icon-magnifier',
};

const QUERY_LABELS = {
  [FILTER_KEYS.ITEMS]: 'Item',
  [FILTER_KEYS.TAGS]: 'Tag',
  [FILTER_KEYS.CATEGORIES]: 'Category',
  [FILTER_KEYS.MANUFACTURERS]: 'Manufacturer',
  [FILTER_KEYS.QUANTITY]: 'Quantity',
  [FILTER_KEYS.STORAGE]: 'Storage',
  [FILTER_KEYS.QUERY]: 'Search query',
};
// eslint-disable-next-line no-unused-vars
const SearchQuery = ({ data = [], onDelete, isEditable }) => (
  <Container>
    <QueryItemContainer>
      {data.map(({ type, text, value }) => {
        if (type === 'color') {
          const handleRemove = () => {
            onDelete({ type: 'colors', value });
          };

          return (
            <Color
              key={value}
              mode={MODES.DELETE}
              color={`${value.includes('#') ? '' : '#'}${value}`}
              deleteAction={isEditable ? handleRemove : undefined}
            />
          );
        }

        return (
          <Tag key={`${type}${text}`}>
            <TagIcon className={QUERY_CLASSNAMES[type]} />
            <span>
              {QUERY_LABELS[type]}
              :&nbsp;&nbsp;
            </span>
            <TagText>{text}</TagText>
            <span onClick={isEditable ? () => onDelete({ type, text, value }) : undefined}>&nbsp;&nbsp;&nbsp;x</span>
          </Tag>
        );
      })}
    </QueryItemContainer>
  </Container>
);

export default SearchQuery;
